var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7132036 11.9999843 5.1392643-5.13926784c.1964454-.1970792.1967622-.51614471 0-.71290706-.1977127-.1970792-.5164612-.1970792-.7135403 0l-5.1389474 5.138951-5.13926432-5.138951c-.19612853-.1970792-.51614437-.1970792-.71290658 0-.19707907.19676235-.19707907.51582786 0 .71290706l5.1389475 5.13926784-5.13863066 5.1386341c-.19707906.1970792-.19707906.5161447 0 .7135407.09853954.0982228.22749641.1479679.35645329.147651.12927373.0003169.25823061-.0494282.35645329-.147651l5.13894748-5.1389509 5.1389474 5.1389509c.0985396.0982228.2278133.1479679.3567702.1479679.12864 0 .2579137-.0497451.3567701-.1479679.1967622-.197396.1967622-.5164615-.0003168-.7135407z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.e115e818.svg";
export { ForwardRef as ReactComponent };